if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        // V4: Re-initialise slider nav after modal opens —
        // SliderComponent binds prev/next listeners on connectedCallback,
        // which fires before the modal is visible. Dispatching a resize
        // event forces the slider to recalculate and re-bind correctly.
        this.initModalSlider();
      }

      initModalSlider() {
        const slider = this.querySelector('slider-component');
        if (!slider) return;
        // Allow the DOM to settle after modal open, then trigger init
        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
          // Also directly call initPages if the SliderComponent exposes it
          if (typeof slider.initPages === 'function') {
            slider.initPages();
          }
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}